import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const COMPLIANCE_TYPES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('COMPLIANCE_TYPES');
export const COMPLIANCE_TYPES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	COMPLIANCE_TYPES_CRUD_ACTION_CONSTANTS
);
